import React from 'react';
import './TwentyEightDays.css';
import Submenu from '../../components/Submenu';
import TwentyEightDays1 from '../../assets/twentyeightdays1.jpg';
import TwentyEightDays2 from '../../assets/twentyeightdays2.jpg';
import TwentyEightDays3 from '../../assets/twentyeightdays3.jpg';
import TwentyEightDays4 from '../../assets/twentyeightdays4.jpg';
import TwentyEightDays5 from '../../assets/twentyeightdays5.jpg';
import TwentyEightDaysPoster from '../../assets/twenty-eight-days-poster.jpeg';
import { useContent } from '../../context/ContentContext';

/* Used only when Airtable is unreachable, keyed by the names in fallbackContent. */
const bundledStills = {
  'twentyeightdays1.jpg': TwentyEightDays1,
  'twentyeightdays2.jpg': TwentyEightDays2,
  'twentyeightdays3.jpg': TwentyEightDays3,
  'twentyeightdays4.jpg': TwentyEightDays4,
  'twentyeightdays5.jpg': TwentyEightDays5,
};

const TwentyEightDays = () => {
  const { twentyEightDaysStills, siteContent, siteImages } = useContent();

  const stills = [...twentyEightDaysStills]
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map((still) => ({ ...still, src: still.imageUrl || bundledStills[still.imageName] }))
    .filter((still) => still.src);

  // The reel reads as two strips of film, so the stills are split across two
  // rows that each divide their width by however many they hold.
  const splitAt = Math.ceil(stills.length / 2);
  const rows = [stills.slice(0, splitAt), stills.slice(splitAt)].filter((row) => row.length);

  return (
    <>
      <div className="multimedia">
        <Submenu />
        <h2>{siteContent.film_28days_logline}</h2>
        <span
          className="film-subheading"
          dangerouslySetInnerHTML={{ __html: siteContent.film_28days_note_html }}
        />
        <div className="twenty-eight-days-container">
          <div className="poster">
            <img
              src={siteImages.film_28days_poster || TwentyEightDaysPoster}
              alt={siteContent.film_28days_logline}
            />
          </div>

          {rows.length > 0 && (
            <div className="reel">
              {rows.map((row) => (
                <div
                  className="reel-row"
                  key={row[0].id || row[0].imageName}
                  style={{ gridTemplateColumns: `repeat(${row.length}, 1fr)` }}
                >
                  {row.map((still) => (
                    <div className="frame" key={still.id || still.imageName}>
                      <img src={still.src} alt={still.name} />
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TwentyEightDays;
